module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("AB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("AJA")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("American Journal of Archaeology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("BECNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("BGBE")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Beiträge zur Geschichte der biblischen Exegese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("BLE")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Bulletin de littérature ecclésiastique")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("BSac")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Bibliotheca Sacra")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("CBQ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("CH")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Church History")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("CJ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Concordia Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("ExAud")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Ex Auditu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("HNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Handbuch zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("HTR")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ICC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Int")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JBL")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JETS")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JR")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal of Religion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JSNT")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal for the Study of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JSNTSup")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JSOTSup")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JTS")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal of Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LNTS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("The Library of New Testament Studies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LXX")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("MDAI")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Mitteilungen des Deutschen archäologischen Instituts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("MT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Masoretic Text")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("NIB")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("The New Interpreter’s Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NICNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NIGTC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Greek Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NovTSup")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Supplements to Novum Testamentum")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('i', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("PSTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Perkins School of Theology Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("RQ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Restoration Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SANT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Studien zum Alten und Neuen Testaments")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SBLSS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Society of Biblical Literature Symposium Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SBT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Studies in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("StPatr")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Studia Patristica")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("TS")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("TU")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Texte und Untersuchungen")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("WBC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Word Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("WTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Westminster Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("WUNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("ZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53dde613","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 69
// module chunks = 0